"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DATE_FORMAT = void 0;
var DATE_FORMAT = {
  MONTH_SHORT_DAY_YEAR: 'MMM DD, YYYY',
  MONTH_SHORT_DAY_YEAR_AT_TIME: 'MMM DD, YYYY [at] hh:mma',
  ISO_DATE: 'YYYY-MM-DD',
  ISO_STRING: 'YYYY-MM-DDTHH:mm:ss.sssZ',
  MONTH_LONG_YEAR: 'MMMM YYYY',
  TIME_MONTH_SHORT_DAY_YEAR: 'hh:mma MMM DD, YYYY',
  DAY_MONTH_YEAR_AT_TIME: 'DD/MM/YYYY [at] h:mm a',
  DAY_FULL_MONTH_YEAR_AT_TIME: 'Do MMMM YYYY [at] h:mma',
  DAY_SHORT_FULL_MONTH_COMMA_YEAR: 'D MMMM, YYYY',
  DAY_SHORT_FULL_MONTH_COMMA_YEAR_AT_TIME: 'D MMMM, YYYY [at] h:mma',
  MINUTES_SECONDS: 'mm:ss'
};
exports.DATE_FORMAT = DATE_FORMAT;